module.exports = __webpack_public_path__ + "img/src/components/DocumentList/pdf_image.png?e7cf0ee3";